import { render } from "./LineColor.vue?vue&type=template&id=5f000b48"
import script from "./LineColor.vue?vue&type=script&lang=js"
export * from "./LineColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__